import { render, staticRenderFns } from "./ModattaNewOfferPreview.vue?vue&type=template&id=6fc9482e&scoped=true"
import script from "./ModattaNewOfferPreview.vue?vue&type=script&lang=js"
export * from "./ModattaNewOfferPreview.vue?vue&type=script&lang=js"
import style0 from "./ModattaNewOfferPreview.vue?vue&type=style&index=0&id=6fc9482e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc9482e",
  null
  
)

export default component.exports